import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Target: React.FC = () => {
    return (
        <div className="aimed-target">
            <FullWrapper>
                <div className="aimed-targetWrapper">
                    <div className="aimed-targetLeft">Цель</div>
                    <div className="aimed-targetRight">
                        Создать в&nbsp;стране технологию для первичной диагностики заболеваний
                        с&nbsp;помощью искусственного интеллекта. Для решения этой глобальной цели
                        и&nbsp;преодоления технологического барьера в&nbsp;медицине проводятся
                        конкурсы AI&rsquo;m Finder и&nbsp;AI&rsquo;m Doctor
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Target;